import { render, staticRenderFns } from "./cargoWarehousingEditAddress.vue?vue&type=template&id=5d40c63f&scoped=true"
import script from "./cargoWarehousingEditAddress.vue?vue&type=script&lang=js"
export * from "./cargoWarehousingEditAddress.vue?vue&type=script&lang=js"
import style0 from "./cargoWarehousingEditAddress.vue?vue&type=style&index=0&id=5d40c63f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d40c63f",
  null
  
)

export default component.exports